import {Component, OnDestroy, OnInit} from '@angular/core';
import {Paths, PathNames} from '../../../../config/config';
import {CatalogService} from '../../../providers/services/catalog.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-homepage-product-in-evidence',
  templateUrl: './homepage-product-in-evidence.component.html',
  styleUrls: ['./homepage-product-in-evidence.component.scss']
})
export class HomepageProductInEvidenceComponent implements OnInit, OnDestroy {

  public readonly Paths = Paths;
  public readonly PathNames = PathNames;

  private readonly subscriptions: Subscription = new Subscription();

  public serie;

  constructor(private catalogService: CatalogService) {

    this.subscriptions.add(
      this.catalogService.getSerieInEvidence().subscribe(({body: {data: {serie}}}) => {
        this.serie = serie;
      })
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
